import { render, staticRenderFns } from "./EtapaInstalacao.vue?vue&type=template&id=d9fc591c"
import script from "./EtapaInstalacao.vue?vue&type=script&lang=js"
export * from "./EtapaInstalacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports